export enum eEstateType {
  feeSimple = 'fee_simple',
  leasehold = 'leasehold',
  lifeEstate = 'life_estate',
  remainderOfALifeEstate = 'remainder_of_a_life_estate',
}

export enum prettyEstateTypeLabels {
  fee_simple = 'Fee Simple',
  leasehold = 'Leasehold',
  life_estate = 'Life Estate',
  remainder_of_a_life_estate = 'Remainder of a Life Estate',
}
